<template>
  <div class="neu-cards-slider1">
    <b-row class="section centered d-flex neu-cards-slider">
      <div class="my-auto">
        <b-col class="text-center my-auto pt-lg-0 pt-5 pb-sm-5">
          <h3>{{ title }}</h3>
        </b-col>
        <div class="row mx-auto pt-5">
          <b-col v-for="card in cards" :key="cards[card]"
            :class="{ 'card-ctn': true}">
            <div class="mx-auto">
              <neu-card :src="card.src" :title="card.title" :subtitle="card.subtitle" :titleLines="card.titleLines"
                :subtitleLines="card.subtitleLines" :iconColor="iconsColor"></neu-card>
            </div>
          </b-col>
        </div>
      </div>
    </b-row>
  </div>
</template>

<script>
import NeuCard from './NeuCard.vue'
import NeuCardsSlider2 from '@/components/base/ui/NeuCardsSlider2'

export default {
  name: 'neu-cards-four-elements',
  components: {
    NeuCard,
    NeuCardsSlider2
  },
  props: {
    cards: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    cols: {
      type: [String, Number],
      required: false,
      default: 3
    },
    iconsColor: {
      type: String,
      required: false
    }
  },
  computed: {
    getColSize () {
      return 12 / this.cols
    }
  },
  mounted () {
    setTimeout(() => {
      // Calculate min-height of neu-cards
      const cards = document.querySelectorAll('.neu-card')
      const minHeight = Math.max(...Array.prototype.slice.call(cards).map((card) => card.offsetHeight))
      cards.forEach((card) => {
        card.style.minHeight = `${minHeight}px`
      })
    }, 200)
  }
}
</script>

<style lang="scss">
// .section {
//   padding-left: 7rem !important;
// }
.img-icon {
        margin: initial !important;
        float: left;
        &.vertical {
          height: 80px;
          @include mobile {
            height: 120px;
          }
        }
        &:not(.vertical) {
          width: 80px;
          @include mobile {
            width: 120px;
          }
        }

        object-fit: cover;
      }
.neu-cards-slider1 {
  @include desktop {
  .neu-cards-slider {
    /* @include media(mobile, tablets) {
      .row {
        display: block;
        overflow-x: auto;
        overflow-y: hidden;
        white-space: nowrap;

        [class*="col-"] {
          display: inline-block;
          width: 100%;
        }
      }
    }

    @include media(tablets,mobile) {
      .row {
        margin-bottom: 2rem;

        &::-webkit-scrollbar {
          height: 3px;
        }
        
        &::-webkit-scrollbar-track {
          background-color: $gray-600;
          border-radius: 100px;
        }
        
        &::-webkit-scrollbar-thumb {
          background-color: $black;
          border-radius: 100px;
        }

        span {
          white-space: normal;
        }
      }
    } */

    .card-ctn {
      display: flex;
  @include mobile {
        // padding: 0 4rem !important;
        padding-right: 3rem !important;
        padding-left: 3rem !important;
      }
      @include desktop {
        &.less-cols {
          padding: 0 1rem !important;
        }
         @media screen and (min-width: 700px) and (max-width: 1550px) {
        padding: 0 2rem !important;
        } 
        padding: 0 4rem;
      }
    
      @include desktop-sm {
        padding: 0 2rem;
      }
     /*  @include tablets {
        padding: 0;
      }
      @include media(tablets, mobile) {
        margin-right: 5rem;
        padding-right: 4rem;
        padding-left: 4rem;
        padding-top: 4rem;
        padding-bottom: 2rem;
      } */

      .neu-card {
        display: flex;
        @include desktop {
          padding: 1rem;
          min-height: 300px;
          max-width: 350px;
          svg {
            width: 60%;
          }
        }
        @include desktop-sm {
          padding: 0rem;
          min-height: 300px;
          max-width: 250px;
        }

        /* @include tablets {
          padding: 4rem;
          width: 100%;
          max-width: none;

          span {
            margin: auto;
          }
        }

        @include mobile {
          padding: 5rem 3rem;
          width: 25%;
          margin-bottom: 3rem;
          min-height: 280px;
        }*/
      }
      .neu-card-rates {
        display: flex;
        @include desktop {
          padding: 5rem;
          min-height: 500px;
          max-width: 220px;
        }
        @include desktop-sm {
          padding: 0rem 5rem;
          min-height: 300px;
          max-width: 250px;
        }

        /* @include tablets {
          padding: 7rem;
          width: 100%;
          max-width: none;

          span {
            margin: auto;
          }
        }

        @include mobile {
          padding: 5rem 3rem;
          margin-bottom: 3rem;
          min-height: 280px;
        }*/
      }
    }
  }
}
  @include mobile {
  .neu-cards-slider {
    /* @include media(mobile, tablets) {
      .row {
        display: block;
        overflow-x: auto;
        overflow-y: hidden;
        white-space: nowrap;

        [class*="col-"] {
          display: inline-block;
          width: 100%;
        }
      }
    }

    @include media(tablets,mobile) {
      .row {
        margin-bottom: 2rem;

        &::-webkit-scrollbar {
          height: 3px;
        }
        
        &::-webkit-scrollbar-track {
          background-color: $gray-600;
          border-radius: 100px;
        }
        
        &::-webkit-scrollbar-thumb {
          background-color: $black;
          border-radius: 100px;
        }

        span {
          white-space: normal;
        }
      }
    } */

    .card-ctn {
      display: flex;
  @include mobile {
        // padding: 0 4rem !important;
        padding-right: 3rem !important;
        padding-left: 3rem !important;
        padding-bottom: 3rem !important;

      }

      .neu-card {
        display: flex;
      }
      .neu-card-rates {
        display: flex;
      }
    }
  }
}
}
  @include media(mobile, tablets) {
    .neu-cards-slider-funct {
      padding-right: 1.15rem !important;
      padding-left: 1.15rem !important;
    }
  }
  </style>



// WEBPACK FOOTER //
// src/components/base/ui/NeuCardsFourElements.vue